/* eslint-disable react-hooks/exhaustive-deps */
import {
  DndContext,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { UndoIcon } from "@lhd/assets";
import ButtonCommon from "@lhd/components/ButtonCommon";
import ModalConfirm from "@lhd/components/Modal/ModalConfirm";
import PaginationCustom from "@lhd/components/PaginationCustom";
import TableDiv from "@lhd/components/TableDiv";
import ToolbarSeparator from "@lhd/components/ToolbarSeparator";
import ViewModeSwitch from "@lhd/components/ViewModeSwitch";
import WrapperDetail from "@lhd/components/Wrapper";
import { BUTTON_HEIGHT } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import { Form, Tooltip } from "antd";
import { FC, useMemo, useState } from "react";
import { BiColumns, BiPlus } from "react-icons/bi";
import { UploadStatusProvider } from "../../contexts/UploadStatusContext";
import BusinessTripReportsCalculator from "../../LayoutApp/BusinessTripReportsCalculator";
import EditPage from "../EditPage";
import FilterPanelWrapper from "./components/FilterPanelWrapper";
import ModalShareRecord from "./components/ModalShareRecord";
import SortableRow from "./components/SortableRow";
import useAppList, { AppTableRow, ReceivedProps } from "./hook";
import { Styles } from "./styled";
import { APP_TYPES } from "../../constants";
import { STATUS_BANNED } from "../../untils";

const AppList = (props: ReturnType<typeof useAppList>) => {
  const {
    dataSource,
    selectionDataList,
    columns,
    form,
    refTable,
    isEditing,
    recordIdEditing,
    numberRowAddNew,
    // delete
    selectedRecordIds,
    isDeleting,
    isOpenDeletedModal,
    onCancelModalDelete,
    handleDelete,
    handleOpenModalDelete,
    // done delete
    isOpenShareModal,
    onCancelModalShare,
    handleOpenModalShare,
    handleAddNewRow,
    handleSetFilter,
    filterData,
    filter,
    total,
    displaySize,
    filterInfo,
    setFilterInfo,
    handleNavigateCreatePage,
    handleNavigateSheetPage,
    appParts,
    orderedAppParts,
    appId,
    permission,
    isLoading,
    isLoadingApp,
    refetchRecords,
    sortableItems,
    handleDragEnd,
    columnOrder,
    handleColumnWidthsChange,
    handleColumnWidthsEnd,
    handleColumnOrderChange,
    isOpenQuickView,
    handleCloseQuickView,
    handleViewDetail,
    appType,
    idSelected,
    isDisabledEdit,
    showCopyButton,
    hideCreateButtons,
    isDisabledView,
    configShowBtnsOnHeader,
    configBtnQuickView,
    companyId,
    isEnableDeleteBtn,
    isEnableShareBtn,
    page,
    pageSize,
    handleChangePagination,
    renderExtendActionHeader,
    additionalFilter,
    // height,
    fontSize,
    quickButtonDirection,
    appPartUserRecordPermissions,
  } = props;

  const sensors = useSensors(useSensor(PointerSensor));
  const isDragDisabled =
    isEditing || (appPartUserRecordPermissions ? false : !permission?.edit);

  const typeShare = configShowBtnsOnHeader?.typeShare ?? "single";
  const [viewMode, setViewMode] = useState<"view" | "record">("view");
  const height = BUTTON_HEIGHT[displaySize] ?? BUTTON_HEIGHT.small;

  const isShareDisabled =
    isEditing ||
    (typeShare === "single" && selectedRecordIds?.length !== 1) ||
    !selectedRecordIds?.length ||
    (appPartUserRecordPermissions ? !isEnableShareBtn : !permission?.edit);

  const isDisabledShareBtn =
    typeShare === "single" && selectedRecordIds?.length > 1;

  const isDisabledDeleteBtn =
    !(selectedRecordIds && selectedRecordIds?.length) ||
    isEditing ||
    (appPartUserRecordPermissions ? !isEnableDeleteBtn : !permission?.delete);

  const tableHeightOffset = useMemo(() => {
    return displaySize === DISPLAY_SIZES.LARGE
      ? -24
      : displaySize === DISPLAY_SIZES.MEDIUM
      ? -12
      : -10;
  }, [displaySize]);

  return (
    <Styles
      className={`${(isEditing && "editing") || ""}`}
      text_scale={displaySize}
    >
      <div className="d-flex align-item-center justify-between py-1 sticky-buttons-header">
        <div className="d-flex flex-wrap gap-2 align-item-center">
          {configShowBtnsOnHeader?.showUndoRedoButtons && (
            <>
              <Tooltip title="開発中" color="#6BC77A">
                <div>
                  <ButtonCommon
                    icon={<UndoIcon direction="right" />}
                    name="元に戻す"
                    disabled={true}
                    style={{
                      height: height + 5,
                      fontSize: fontSize,
                      width: "fit-content",
                      minWidth: "unset",
                    }}
                    height={height}
                  />
                </div>
              </Tooltip>
              <Tooltip title="開発中" color="#6BC77A">
                <div>
                  <ButtonCommon
                    name="やり直し"
                    iconRight={<UndoIcon />}
                    disabled={true}
                    style={{
                      height: height + 5,
                      fontSize: fontSize,
                      width: "fit-content",
                      minWidth: "unset",
                    }}
                    height={height}
                  />
                </div>
              </Tooltip>
              {(configShowBtnsOnHeader?.showDelete ||
                configShowBtnsOnHeader?.showShare ||
                configShowBtnsOnHeader?.showViewModeSwitch ||
                configShowBtnsOnHeader?.showToSheet ||
                configShowBtnsOnHeader?.showAddNew) && (
                <ToolbarSeparator height={height + 5} />
              )}
            </>
          )}
          {configShowBtnsOnHeader?.showDelete && (
            <ButtonCommon
              name="一括削除"
              className={
                selectedRecordIds &&
                selectedRecordIds?.length > 0 &&
                !isEditing &&
                (appPartUserRecordPermissions
                  ? isEnableDeleteBtn
                  : permission?.delete)
                  ? "btn-delete"
                  : "btn-delete-disable"
              }
              disabled={
                isDisabledDeleteBtn || configShowBtnsOnHeader?.disableDelete
              }
              type="default"
              onClick={() => {
                handleOpenModalDelete();
              }}
              style={{
                borderRadius: 2,
                height: height + 5,
                fontSize: fontSize,
              }}
            />
          )}
          {configShowBtnsOnHeader?.showShare && (
            <Tooltip
              title={
                isDisabledShareBtn ? (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span>
                      複数のレコードを同時に他社へコピーすることはできません。
                    </span>
                    <span>1件のみ選択してください。</span>
                  </div>
                ) : null
              }
              open={isDisabledShareBtn ? undefined : false}
              placement="bottom"
              getPopupContainer={() => document.body}
              overlayClassName="worker-tooltip"
              mouseEnterDelay={0.2}
              mouseLeaveDelay={0.1}
              destroyTooltipOnHide
              trigger={["hover"]}
              align={{ offset: [12, -10] }}
            >
              <span
                className={
                  isDisabledShareBtn ? "tooltip-disabled-wrap" : "tooltip-wrap"
                }
              >
                <ButtonCommon
                  name="他社へ共有"
                  type="default"
                  disabled={
                    isShareDisabled || configShowBtnsOnHeader?.disableShare
                  }
                  onClick={() => {
                    handleOpenModalShare();
                  }}
                  style={{
                    borderRadius: 2,
                    height: height + 5,
                    fontSize: fontSize,
                  }}
                />
              </span>
            </Tooltip>
          )}
          {(configShowBtnsOnHeader?.showDelete ||
            configShowBtnsOnHeader?.showShare) &&
            (configShowBtnsOnHeader?.showViewModeSwitch ||
              configShowBtnsOnHeader?.showToSheet ||
              configShowBtnsOnHeader?.showAddNew) && (
              <ToolbarSeparator height={height + 5} />
            )}
          {configShowBtnsOnHeader?.showViewModeSwitch && (
            <>
              <ViewModeSwitch
                viewMode={viewMode}
                onViewModeChange={setViewMode}
                fontSize={fontSize}
                height={height + 5}
              />
              {(configShowBtnsOnHeader?.showToSheet ||
                configShowBtnsOnHeader?.showAddNew) && (
                <ToolbarSeparator height={height + 5} />
              )}
            </>
          )}
          {configShowBtnsOnHeader?.showToSheet && (
            <ButtonCommon
              icon={<BiColumns size={18} />}
              name="一括編集"
              type="default"
              onClick={handleNavigateSheetPage}
              disabled={
                configShowBtnsOnHeader?.disableToSheet || !permission.edit
              }
              style={{
                height: height + 5,
                fontSize: fontSize,
              }}
            />
          )}
          {configShowBtnsOnHeader?.showAddNew && (
            <>
              <ButtonCommon
                name="新規行作成（フォーム）"
                icon={<BiPlus size={18} />}
                onClick={() => {
                  handleNavigateCreatePage();
                }}
                className="btn-create"
                loading={isLoadingApp}
                disabled={
                  isEditing ||
                  !permission?.create ||
                  !appId ||
                  configShowBtnsOnHeader?.disableAddNew
                }
                style={{
                  height: height + 5,
                  fontSize: fontSize,
                }}
              />
              {!configShowBtnsOnHeader?.hideAddNewRecordButton && (
                <ButtonCommon
                  name="行追加"
                  icon={<BiPlus size={18} />}
                  onClick={() => {
                    handleAddNewRow(1);
                  }}
                  className="btn-create"
                  disabled={
                    isEditing ||
                    !permission.create ||
                    configShowBtnsOnHeader?.disableAddNew
                  }
                  style={{
                    height: height + 5,
                    fontSize: fontSize,
                  }}
                />
              )}
            </>
          )}
          {renderExtendActionHeader && renderExtendActionHeader()}
          {(configShowBtnsOnHeader?.showUndoRedoButtons ||
            configShowBtnsOnHeader?.showDelete ||
            configShowBtnsOnHeader?.showShare ||
            configShowBtnsOnHeader?.showViewModeSwitch ||
            configShowBtnsOnHeader?.showToSheet ||
            configShowBtnsOnHeader?.showAddNew ||
            !!renderExtendActionHeader) && (
            <ToolbarSeparator height={height + 5} />
          )}
          <PaginationCustom
            displaySize={displaySize}
            disabled={isEditing || selectedRecordIds.length > 0}
            pageSize={pageSize}
            current={page}
            total={total}
            onChange={handleChangePagination}
          />
        </div>
      </div>
      <Form form={form}>
        {appType === APP_TYPES.BUSINESS_TRIP_REPORTS && (
          <>
            {recordIdEditing && (
              <BusinessTripReportsCalculator
                form={form}
                appPartsFlat={appParts || []}
                appType={appType}
                recordId={recordIdEditing}
              />
            )}
            {numberRowAddNew > 0 && (
              <BusinessTripReportsCalculator
                form={form}
                appPartsFlat={appParts || []}
                appType={appType}
                recordId="new"
              />
            )}
          </>
        )}
        <DndContext sensors={sensors} onDragEnd={handleDragEnd}>
          <SortableContext
            items={sortableItems}
            strategy={verticalListSortingStrategy}
          >
            <TableDiv<AppTableRow>
              onScroll={(direction) => {
                if (direction === "horizontal" && filterInfo.open) {
                  setFilterInfo((pre) => ({ ...pre, open: false }));
                }
              }}
              ref={refTable}
              isLoading={isLoading}
              style={{ transition: "0.3s" }}
              columnOrder={columnOrder}
              onColumnWidthsChange={handleColumnWidthsChange}
              onColumnWidthsEnd={handleColumnWidthsEnd}
              onColumnOrderChange={handleColumnOrderChange}
              rowKey={(record) => record.key}
              dataSource={dataSource}
              columns={columns}
              columnResize
              columnReorder
              renderRow={(record, index, row) => {
                if (record.isNew) {
                  return (
                    <div style={{ position: "sticky", bottom: 0 }}>{row()}</div>
                  );
                }
                return (
                  <SortableRow
                    id={record.key}
                    disabled={isDragDisabled || record.isNew}
                  >
                    {(dragHandleProps) => row(dragHandleProps)}
                  </SortableRow>
                );
              }}
              displaySize={displaySize}
              rowClassName={(record) => {
                let className = "";
                if (record.isNew) className += "row_new";
                if (record.id === recordIdEditing) className += "row_editing ";
                if (selectedRecordIds.includes(record.id))
                  className += "selected";
                if (appType === APP_TYPES.COMPANY_POLICIES) {
                  const statusColumn = orderedAppParts?.find(
                    (item) => item.name === STATUS_BANNED.statusName,
                  )?.id;

                  const statusRecordValue = statusColumn
                    ? record?.[statusColumn]?.valueFormat
                    : undefined;
                  if (statusRecordValue === STATUS_BANNED.statusValue) {
                    className += "row_banned";
                  }
                }
                return className;
              }}
              scrollVertical="fit"
              isOpenQuickView={isOpenQuickView}
              heightOffset={tableHeightOffset}
            />
          </SortableContext>
        </DndContext>
      </Form>
      {filterInfo.position && (
        <FilterPanelWrapper
          appType={appType}
          appPart={appParts?.find(
            (item: any) => item.id == filterInfo.columnId,
          )}
          appParts={orderedAppParts}
          selectionDataList={selectionDataList}
          filterInfo={filterInfo}
          position={filterInfo.position}
          columnId={filterInfo.columnId || ""}
          setFilterInfo={setFilterInfo as any}
          filterDataFull={filterData}
          handleSetFilter={handleSetFilter}
          filter={filter}
          open={filterInfo.open}
          appId={appId}
          companyId={companyId}
          workerId={props.workerId}
          additionalFilter={additionalFilter}
        />
      )}

      <ModalConfirm
        isSubmitting={isDeleting}
        isOpen={isOpenDeletedModal}
        onCancel={onCancelModalDelete}
        onOk={handleDelete}
        content={"目標を本当に削除しますか?"}
      />

      <ModalShareRecord
        appType={appType}
        open={isOpenShareModal}
        onCancel={onCancelModalShare}
        appId={appId}
        selectedRecordIds={selectedRecordIds}
        onSuccess={() => refetchRecords()}
        typeShare={typeShare}
      />
      <WrapperDetail
        isShowQuickView
        isOpen={isOpenQuickView}
        onClose={handleCloseQuickView}
        handleViewDetail={() => handleViewDetail("view")}
        handleViewEdit={() => handleViewDetail("edit")}
        hideScrollbar
        disabledBtnEdit={isDisabledEdit || configBtnQuickView?.disableEdit}
        disabledBtnView={isDisabledView || configBtnQuickView?.disableView}
        containerHeight={"auto"}
        quickButtonDirection={quickButtonDirection}
      >
        <EditPage
          key={idSelected?.recordId}
          appType={appType}
          permission={{ view: true }}
          idsSelected={idSelected}
          isQuickView={true}
          companyId={companyId}
          isQuickViewMode
        />
      </WrapperDetail>
    </Styles>
  );
};

const AppListWithHook: FC<ReceivedProps> = (props) => (
  <AppList {...useAppList(props)} />
);

export const AppListForm: FC<ReceivedProps> = (props) => (
  <UploadStatusProvider>
    <AppListWithHook {...props} />
  </UploadStatusProvider>
);

export default AppListForm;
